import { useEffect, useState, useContext } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import {
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Row,
  Col,
  CardSubtitle,
  Button,
} from 'reactstrap'
import DatePicker from 'reactstrap-date-picker'
import CustomSelect from '../../components/elements/CustomSelect'
import MainContainer from '../../components/modules/containers/MainContainer'
import Preloader from '../../components/modules/loader'
import { patientHome } from '../../breadcrumRoutes.js'
import { getMembers } from '../../api/member'
import { userRoles } from '../../mock-data/roles'
import VisitContext from '../../store/visitContext'
import ExportVisit from '../../excel-export/exportVisit'

const Index = () => {
  const { getData,data } = useContext(VisitContext)
  const [members, setMembers] = useState([])
  const [loading, setLoading] = useState(false)
  const [member, setMember] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEnddate] = useState('')
  const history = useHistory()
  const location = useLocation()


  let memberOptions = members?.map((element) => {
    return {
      value: element.id,
      label: `${element.username} (${
        userRoles.find((role) => role.id == element.role)?.name
      })`,
    }
  })

  const searchData = () => {
    var query = ''
    if (startDate && endDate) {
      query += `&startDate=${startDate}&endDate=${endDate}`
    }
    if (member) {
      query += `&member=${member}`
    }
    history.push(`/visits?${query.substr(1)}`)
  }

  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true)
      let responseMember = await getMembers()
      setMembers(responseMember)

      let params = {}
      let searchResult = new URLSearchParams(location.search)

      if (searchResult.get('member')) {
        params.member = searchResult.get('member')
      }
      if (searchResult.get('startDate') && searchResult.get('endDate')) {
        params.startDate = searchResult.get('startDate')
        params.endDate = searchResult.get('endDate')
      }
      await getData(params)
      setLoading(false)
    }
    fetchMyAPI()
  }, [getMembers, location])

  return (
    <>
      <MainContainer breadcrums={patientHome}>
        <Card>
          <CardBody>
            <Row>
              <Col md={{ size: 3 }}>
                <FormGroup>
                  <Label for="member">Member</Label>
                  <CustomSelect
                    options={memberOptions}
                    onChange={(val) => setMember(val.value)}
                  />
                </FormGroup>
              </Col>
              <Col md={{ size: 3 }}>
                <FormGroup>
                  <Label for="startdate">Start Date</Label>
                  <DatePicker
                    onChange={(value) => setStartDate(value)}
                    value={startDate}
                  />
                </FormGroup>
              </Col>
              <Col md={{ size: 3 }}>
                <FormGroup>
                  <Label for="startdate">End Date</Label>
                  <DatePicker
                    onChange={(value) => setEnddate(value)}
                    value={endDate}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <br />
                  <Button onClick={() => searchData()}>Search</Button>
                  <ExportVisit datasets={data} isDisabled={!data ? true : false} style={{marginLeft:'15px'}}/>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
        {loading && <Preloader /> }
        {!loading && (
          <Row>
            {
              <VisitContext.Consumer>
               
                {({ data }) =>
                  data.map((data,i) => (
                    <Col key={i} md={{ size: 4, offset: 4 }}>
                      <Card  className="main-card">
                        <CardBody className="d-flex flex-column justify-content-center">
                          <CardTitle className="mb-2 text-center">
                            <strong>Date</strong> : {data.date.substr(0, 10)}
                          </CardTitle>
                          <CardTitle className="mb-2 text-center">
                            <strong>Visit Person</strong> :{' '}
                            {data.visitor.username}
                          </CardTitle>
                          <CardSubtitle className="mb-2 text-center">
                            <strong>Township</strong> :{' '}
                            {data.townships.map((e) => e.short_code + ',')}
                          </CardSubtitle>
                          <Link to={`/visit-detail/${data.id}`}>
                            <Button outline className="view-btn">
                              View Detail
                            </Button>
                          </Link>
                        </CardBody>
                      </Card>
                    </Col>
                  ))
                }
              </VisitContext.Consumer>
            }
          </Row>
        )}
      </MainContainer>
    </>
  )
}

export default Index
